import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from '@/views/Landing/Landing';
import { Personvern } from '@/views/Personvern/Personvern';
import { Kontakt } from '@/views/Kontakt/Kontakt';
import { Profil } from '@/views/Profil/Profil';
import { NotFound } from '@/views/NotFound/NotFound';
import { AdminGate } from '@/admin/AdminGate';
import { AdminShell } from '@/admin/AdminShell';
import { AdminUsers } from '@/admin/pages/AdminUsers';
import { AdminAccessRequests } from '@/admin/pages/AdminAccessRequests';
import { AdminContent } from '@/admin/pages/AdminContent';
import { AdminContentEditor } from '@/admin/pages/AdminContentEditor';
import { AdminAuditLog } from '@/admin/pages/AdminAuditLog';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/personvern" element={<Personvern />} />
        <Route path="/kontakt" element={<Kontakt />} />
        <Route path="/profil" element={<Profil />} />
        {/* Full-screen editor takeover — outside the AdminShell sidebar layout (ADR-0020). */}
        <Route
          path="/admin/innhold/:slug"
          element={
            <AdminGate>
              <AdminContentEditor />
            </AdminGate>
          }
        />
        <Route
          path="/admin"
          element={
            <AdminGate>
              <AdminShell />
            </AdminGate>
          }
        >
          <Route index element={<Navigate to="users" replace />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="access-requests" element={<AdminAccessRequests />} />
          <Route path="innhold" element={<AdminContent />} />
          <Route path="audit-log" element={<AdminAuditLog />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
